import React, {
  Children,
  cloneElement,
  memo,
  RefObject,
  ReactNode,
  useMemo,
  useState,
  JSX,
} from 'react'

import styled from '@emotion/styled'

import { useHandler } from '@surglogs-app/hooks'

import { Text } from '../uiKit/components/Text'

import { TransparentLineEnd } from './TransparentLineEnd'

export const TextLineText = styled(Text)`
  display: inline-block; // NOTE: must be block-like otherwise style returns auto width
`

type Props = JSX.IntrinsicElements['div']
interface TextLineProps extends Props {
  children: ReactNode | string
  width?: number | RefObject<HTMLElement>
  offset?: number
  fadeOutColor?: string
}

const getWidth = (e: HTMLElement | null): number | undefined => {
  if (e) {
    const { width } = window.getComputedStyle(e)
    return parseInt(width, 10)
  }
}

const toNumber = (value: any): number => Number(value) || 0

const Component = memo(
  ({ children, width, offset, fadeOutColor, ...rest }: TextLineProps) => {
    const [isTransparent, setIsTransparent] = useState<boolean>(false)
    const setRef = useHandler((e: HTMLElement | null) => {
      const childrenWidthNumber = getWidth(e)
      const parentWidth = typeof width !== 'number' ? getWidth(e) : width
      if (
        toNumber(childrenWidthNumber) + toNumber(offset) >
        toNumber(parentWidth)
      ) {
        setIsTransparent(true)
      }
    })
    const ref = width != null ? setRef : undefined

    const content = useMemo(
      () =>
        /* eslint-disable-next-line no-nested-ternary */
        typeof children === 'string' ? (
          <TextLineText {...{ ref }}>{children}</TextLineText>
        ) : ref ? (
          cloneElement(Children.only(children) as any, { ref })
        ) : (
          children
        ),
      [children, ref],
    )

    return (
      <div {...rest}>
        {content}
        {isTransparent ? (
          <TransparentLineEnd {...{ color: fadeOutColor }} />
        ) : null}
      </div>
    )
  },
)

// TODO: this needs better name
export const TextLine = styled(Component)`
  overflow: hidden;
`
